<template>
    <div class="all">
        <div class="container">
            <img src="../../static/images/quessBg.png" alt="" style="display:block;margin:0 auto;">
            <div class="h-auto questionCont">
                <div v-for="(item,index) in questionList" :key="index">
                    <questionAnswer v-if="item.type == 4" :questionData="item" :sortNum="index+1" @getAnswerdata="getAnswerdata" :isReset="isReset"></questionAnswer>
                    <questionRadio v-else-if="item.type == 1" :questionData="item" :sortNum="index+1" @getRadiodata='getRadiodata' :isReset="isReset"></questionRadio>
                    <questionScore v-else-if="item.type == 3" :questionData="item" :sortNum="index+1" @getScoredata='getScoredata' :isReset="isReset"></questionScore>
                    <questionSorting v-else-if="item.type == 5" :questionData="item" :sortNum="index+1" @getSortingdata="getSortingdata" :isReset="isReset"></questionSorting>
                    <questionCheck v-else :questionData="item" :sortNum="index+1" @getCheckboxdata='getCheckboxdata' :isReset="isReset"></questionCheck>
                </div>
                <div class="d-flex justify-around" style="width:300px;margin:0 auto;margin-top:80px;">
                    <el-button type="info" @click="resetAnswer">重置</el-button>
                    <el-button type="primary" @click="subAnswer">提交</el-button>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import questionAnswer from '../components/questionnaire/questionAnswer';
import questionCheck from '../components/questionnaire/questionCheck';
import questionRadio from '../components/questionnaire/questionRadio';
import questionScore from '../components/questionnaire/questionScore';
import questionSorting from '../components/questionnaire/questionSorting';
export default {
    components:{questionAnswer,questionSorting,questionScore,questionRadio,questionCheck},
    data() {
        return {
          questionList:[],
          answerList:[],
          resultList:[],
          isReset:false
        }
    },
    mounted() {

    },
    created() {
		this.getQuestions()
    },
    methods: {
        getQuestions(){
            let that = this;
            that.$api.get('user/feedback/info-questionnaire',null,r =>{
                that.$parent.returnCode(r,function(){
                    console.log('问卷调查',r)
                    that.questionList = r.data;

                })
            })
        },
        getRadiodata(res){
            console.log('单选：',res)
            this.answerFilter(res)
        },
        getAnswerdata(res){
            console.log('问答：',res)
            this.answerFilter(res)
        },
        getSortingdata(res){
            console.log('排序',res)
            this.answerFilter(res)
        },
        getCheckboxdata(res){
            console.log('多选题',res)
            this.answerFilter(res)
        },
        getScoredata(res){
            console.log('评分',res)
            this.answerFilter(res) 
        },
        //多种题型重新填写去重
        answerFilter(res){
            this.resultList.push(res)
            this.answerList = [];
            let obj = {};
            for(var i =0; i<this.resultList.length; i++){
               if(!obj[this.resultList[i].id]){
                  this.answerList.push(this.resultList[i]);
                  obj[this.resultList[i].id] = true;
               }
            }
            console.log('最终结果：',this.answerList)
        },
        subAnswer(){
            let that = this;
            if(this.answerList.length<this.questionList.length){
                this.$utils.alertText('还有题未完成作答');
            }else{  
                that.$api.post('user/feedback/commit-questionnaire',{data:that.answerList},r =>{
                    that.$parent.returnCode(r,function(){
                        //console.log('问卷调查提交',r)
                        that.$utils.alertText('提交成功');
                        that.resetAnswer();
                        that.$store.commit('show/changeShowData', 2)
                        setTimeout(()=>{
                            window.history.go(-1);
                        },1000)
                    })
                })
            }
        },
        resetAnswer(){
            this.isReset = true;
            this.answerList = [];
            this.resultList = [];
            setTimeout(()=>{
                this.isReset = false;
            },500)
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/questionnaire.vue